import { Collapse } from 'antd';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { ReactComponent as Down } from '../../../../assets/icons/arrowDown.svg';
import { ReactComponent as Up } from '../../../../assets/icons/arrowUp.svg';
import LXSpinner from '../../spinner/lx_spinner';
const { Panel } = Collapse;

interface LXExpandableProps<T> {
  datas: T[];
  panelBuilder: (data: T, index: number) => ReactNode;
  separator: ReactNode;
  width?: number;
  lastSeparator?: boolean;
  isLoading?: boolean;
}

interface LXExpandableLoadingContainerProps {
  width?: number;
}

const LXExpandableLoadingContainer = styled.div<LXExpandableLoadingContainerProps>`
  width: ${(props) => `${props.width}px`};
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LXExpandable = <T,>(props: LXExpandableProps<T>) => {
  const items: ReactNode[] = [];

  const buildItems = () => {
    props.datas.forEach((data, idx) => { //FIXME - 
      const item = props.panelBuilder(data, idx);
      items.push(item);
      const separator = (
        <Panel
          key={'s' + idx.toString()}
          showArrow={false}
          header={props.separator}
          collapsible={'disabled'}
        ></Panel>
      );
      if (idx === props.datas.length - 1) {
        if (props.lastSeparator) {
          items.push(separator);
        }
      } else {
        items.push(separator);
      }
    });
  };

  buildItems();

  if (props.isLoading) {
    return (
      <LXExpandableLoadingContainer width={props.width}>
        <LXSpinner></LXSpinner>
      </LXExpandableLoadingContainer>
    );
  }

  return (
    <Collapse
      ghost
      style={{ width: props.width }}
      expandIconPosition={'end'}
      expandIcon={(panelProps) =>
        panelProps.isActive ? <Up></Up> : <Down></Down>
      }
    >
      {items}
    </Collapse>
  );
};

export default LXExpandable;
